import React from 'react';
import { CommonIconProps } from './Icon';

const ChevronRightThinIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      d="M1.40002 0.571289L8.4286 7.59986C8.48326 7.65116 8.52683 7.71313 8.55661 7.78192C8.58639 7.85072 8.60176 7.92489 8.60176 7.99986C8.60176 8.07483 8.58639 8.149 8.55661 8.2178C8.52683 8.28659 8.48326 8.34856 8.4286 8.39986L1.40002 15.4284"
      stroke={color}
      strokeWidth="1.14286"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
);

export default ChevronRightThinIcon;

ChevronRightThinIcon.prototype.svgPropOverrides = { viewBox: '0 0 10 16' };
